<script lang="ts" setup>
import { BadgeVariant } from '@docue/docue-ui-v2/ui-components/DTBadge/types'

import type { AnyTemplate } from '~/types'

const props = defineProps<{
  template: AnyTemplate
}>()

const { t } = useI18n()

const label = computed(() => {
  switch (true) {
    case isTailoredTemplate(props.template):
      return { variant: BadgeVariant.purple, text: t('template.type.tailored') }
    case isCustomUserTemplate(props.template):
      return { variant: BadgeVariant.blue, text: t('template.type.custom') }
    case isPrefilledUserTemplate(props.template):
      return { variant: BadgeVariant.yellow, text: t('template.type.prefilled') }
    default: return undefined
  }
})
</script>

<template>
  <DTBadge
    v-if="label"
    class="!text-gray-700"
    :variant="label.variant"
  >
    {{ label.text }}
  </DTBadge>
</template>
